import { BreadcrumbType } from './components/Breadcrumbs';

import React from 'react';
import styled, { css } from 'styled-components';
import Breadcrumbs from './components/Breadcrumbs';
import { MAIN_CONTENT_WIDTH } from '~/components/organism/NavigationFrame/constants';

export const MAX_CONTAINER_WIDTH = '1300px';

type Props = {
  dataTestId?: string;
  style?: $Object;
  children: React.ReactNode;

  /** Set the max-width of the content container, default is MAIN_CONTENT_WIDTH */
  maxContentWidth?: string;

  /** The breadcrumbs to display */
  breadcrumbs?: Array<BreadcrumbType>;

  /** The testId */
  'data-testid'?: string;

  /** The test object id */
  'data-objectid'?: string;
};
const ContentContainerDefault = React.forwardRef<HTMLDivElement, Props>(
  ({ children, breadcrumbs, maxContentWidth, dataTestId }, ref) => {
    const hasBreadcrumbs = breadcrumbs && breadcrumbs.length !== 0;

    const breadcrumbContainer = hasBreadcrumbs ? (
      <BreadcrumbContainer $fullHeight={hasBreadcrumbs}>
        {hasBreadcrumbs ? <Breadcrumbs breadcrumbs={breadcrumbs} /> : null}
      </BreadcrumbContainer>
    ) : null;

    return (
      <ContentContainerDefaultContainer ref={ref} data-testid={dataTestId}>
        <ContentContainerDefaultContent $maxContentWidth={maxContentWidth}>
          {breadcrumbContainer}
          {children}
        </ContentContainerDefaultContent>
      </ContentContainerDefaultContainer>
    );
  },
);

const BREADCRUMB_HEIGHT = '72px';
const BREADCRUMB_MOBILE_HEIGHT = '50px';

const BreadcrumbContainer = styled.div<{ $fullHeight?: boolean }>`
  display: flex;
  align-items: center;
  ${({ theme, $fullHeight }) => css`
    height: ${$fullHeight ? BREADCRUMB_HEIGHT : theme.space('xl')};

    ${theme.mq.lessThan('tabletLandscape')`
      height: ${BREADCRUMB_MOBILE_HEIGHT};
    `}
  `};
`;

const ContentContainerDefaultContainer = styled.div<{}>`
  display: flex;
  justify-content: center;
  flex-grow: 1;
  flex-direction: column;

  ${({ theme }) => css`
    margin: ${theme.space('xl')} ${theme.space('xxxl')} 0 ${theme.space('xxxl')};

    ${theme.mq.lessThan('tablet')`
      margin: ${theme.space('m')} ${theme.space('m')} 0 ${theme.space('m')};
    `}
  `};
`;

type ContentContainerDefaultContentProps = {
  $maxContentWidth?: string;
};

const ContentContainerDefaultContent = styled.div<ContentContainerDefaultContentProps>`
  width: 100%;
  margin: 0 auto;

  ${({ theme, $maxContentWidth }) => {
    const maxWidth = $maxContentWidth || `${MAIN_CONTENT_WIDTH}px`;

    return css`
      max-width: ${maxWidth};
      padding-bottom: ${theme.space('m')};
    `;
  }}
`;

export default ContentContainerDefault;
